/* eslint-disable class-methods-use-this */
/* eslint-disable no-lonely-if */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */
import * as THREE from 'three';
import * as marietta from './marietta';
import { CorrectionManager } from './marietta/LiDAR/commands';
import { LiDARData } from './marietta/network/LiDARData';
import { ThreeView } from './marietta/view3d/webcad';
import { Mode3DTool } from './marietta/view3d/webcad/util/Mode3DTool';
import { optAutoIntersectMode } from './marietta/view3d/webcad/util/Option3DInterface';
import {
  BUILDING_TYPE_HOUSE,
  BUILDING_TYPE_MANSION,
  CONTROL_ACTIONMODE,
  ITEM_MODE_NO,
  MEASURE_LINE_TOGGLE_BUTTON_SELECTOR,
  PIN_TOGGLE_BUTTON_SELECTOR,
} from './marietta/webcad/Constants';
import { Master, Stage } from './marietta/webcad/model';
import * as marietta3d from './marietta3d';
import { GradeMasterCollection } from './marietta/webcad/collection';
import { BuildDebugMenu } from './marietta/debug/TestTools/BuildDebugMenu';
import { DebugSession } from './marietta/debug/TestTools/starts/DebugSession';

/** 開発環境と判定するURLに含まれる文字列 */
const LOCAL_HOST_NAME = 'localhost';

/** HTMLのdata-infoでデバッグモードが有効な場合の値 */
const DEBUG_MODE_ENABLED_VALUE = '1';

/** webcad APIのパス */
const WEBCAD_API_PATH = '/api/v1/webcad';

/** webcad APIのパス（シェアモード：アカウントなしで参照する共有ルート） */
const SHARE_WEBCAD_API_PATH = '/api/v1/share/webcad';

/** サイト側が起動情報を保存するlocalStorageのキー */
const STARTUP_INFO_STORAGE_KEY = 'bim_viewer';

/** クリップボードに書き込むテキストのMIMEタイプ */
const CLIPBOARD_TEXT_MIME_TYPE = 'text/plain';

/** クリップボードへの書き込み結果を待つ上限（ミリ秒） */
const CLIPBOARD_WRITE_TIMEOUT_MS = 5000;

/** モデルのリンクをコピーを使える企業かを示す起動パラメータのキー */
const MODEL_LINK_SHARE_FLAG_PARAM_KEY = 'model_link_share_flag';

/** モデルのリンクをコピーを表示する起動パラメータの値（前後の空白を除き小文字にして比べる） */
const MODEL_LINK_SHARE_FLAG_ON_VALUES: readonly string[] = ['true', '1'];

declare global {
  let objItemMenuStair: JSON;
  let objItemMenuFitting: JSON;
  let objItemMenuEquipment: JSON;
  let objItemMenuFurniture: JSON;
  let objItemMenuExterior: JSON;
  let Stats: any;
}

export default class Main {
  static headerDropdownMode: boolean;

  static headerDropdownTimer: number;

  constructor() {
    // ページ読込時のイベント
    window.addEventListener('pageshow', this.onPageLoaded);
  }

  /**
   * ページが表示された
   */
  private onPageLoaded = (): void => {
    if (navigator.language.match(/en/i)) {
      document.getElementsByTagName('BODY')[0].classList.add('lang-en');
      marietta.webcad.WebCADGlobal.language = 'en';
    } else {
      document.getElementsByTagName('BODY')[0].classList.add('lang-jp');
      marietta.webcad.WebCADGlobal.language = 'jp';
    }

    THREE.ImageUtils.crossOrigin = '';

    let isDemo;
    // eslint-disable-next-line no-restricted-globals
    switch (location.host) {
      // case 'localhost':
      // case '192.168.0.51':
      case 'webcad.marietta.co.jp':
      case 'webcad-stage.marietta.co.jp':
        isDemo = true;
        break;
      default:
        isDemo = false;
        break;
    }
    function DemoPswd() {
      const setEvents = () => {
        document.getElementById('demopaswd').querySelectorAll('form').forEach((element) => {
          element.addEventListener('submit', check);
        });
        document.getElementById('demopaswd').querySelectorAll('input[type="button"]').forEach((element) => {
          element.addEventListener('click', check);
        });
      };
      const removeEvents = () => {
        document.getElementById('demopaswd').querySelectorAll('form').forEach((element) => {
          element.removeEventListener('submit', check);
        });
        document.getElementById('demopaswd').querySelectorAll('input[type="button"]').forEach((element) => {
          element.removeEventListener('click', check);
        });
      };
      const self = this;
      document.getElementById('demopaswd').style.opacity = '1';
      const check = (e) => {
        e.preventDefault();
        removeEvents();
        const pass = (<HTMLInputElement>document.getElementById('demopaswd').querySelector('input[type="password"]:visible')).value;
        if (!pass) {
          document.getElementById('demopaswd').querySelectorAll('.msg_error').forEach((element) => {
            element.textContent = marietta.webcad.collection.WebCADMessages.getText('ERROR_INPUT_PASSWORD');
          });
          setEvents();
          return;
        }
        fetch(`assets/pwdemo.json?${new Date().getTime()}`, {
          method: 'GET',
        }).then((response) => {
          if (response.status >= 200 && response.status <= 299) {
            return response.json();
          }
          throw Error(response.statusText);
        }).then((list) => {
          let flag = false;
          list.forEach((obj) => {
            if (obj === pass) {
              this.onLoad();
              flag = true;
              self.remove();
            }
          });
          if (!flag) {
            document.getElementById('demopaswd').querySelectorAll('.msg_error').forEach((element) => {
              element.textContent = marietta.webcad.collection.WebCADMessages.getText('ERROR_INPUT_PASSWORD2');
            });
            self.setEvents();
          }
        })
          // eslint-disable-next-line no-shadow
          .catch((e) => {
            console.error(e);
            setEvents();
            // eslint-disable-next-line no-alert
            alert(marietta.webcad.collection.WebCADMessages.getText('ERROR_NETWORK'));
          });
      };

      setEvents();
    }
    DemoPswd();
    if (isDemo) {
      DemoPswd();
    } else {
      document.getElementById('demopaswd').remove();
      try {
        this.onLoad();
      } catch (e) {
        window.addEventListener('DOMContentLoaded', this.onLoad);
      }
    }

    DemoPswd.prototype.remove = () => {
      document.getElementById('demopaswd').remove();
    };

    //右クリック防止
    document.addEventListener('contextmenu', (event) => {
      event.preventDefault();
    })

    // try {
    //     this.onLoad();
    // } catch (e) {
    //     window.addEventListener('DOMContentLoaded', this.onLoad);
    // }
  }

  /**
   * 初期化
   */
  private onLoad(): void {
    marietta.webcad.WebCADGlobal.onFloorChanged = this.onChangeFloor;
    marietta.webcad.WebCADGlobal.onStageResized = Main.onStageResized;
    marietta.webcad.WebCADGlobal.autoMain = null;
    window.removeEventListener('DOMContentLoaded', this.onLoad);

    // ページ遷移イベント
    window.addEventListener('beforeunload', marietta.webcad.WebCADGlobal.pageBeforeUnload);

    // マネージャー
    // モジュール（寸法モード・ピッチ方針）マネージャーは modulePitch setter 等から参照されるため先に生成する
    marietta.webcad.WebCADGlobal.moduleManager = new marietta.webcad.manager.ModuleManager();
    const webcad2Dmanager: marietta.webcad.manager.Plan2DManager = new marietta.webcad.manager.Plan2DManager();
    const MasterManager: marietta.webcad.manager.MasterManager = new marietta.webcad.manager.MasterManager();
    marietta.webcad.WebCADGlobal.masterManager = MasterManager;

    // GETパラメータ取得
    // let info: any = (new URL(document.location.href)).searchParams;
    const info: any = (() => {
      // queryParam -> localStorage
      try {
        return JSON.parse(localStorage.getItem(STARTUP_INFO_STORAGE_KEY) || '{}');
      } catch (_) {
        return {};
      }
    })();
    // localStorage 優先で queryParam の内容も組み込む
    info.get = (key: string) => {
      return info[key] !== undefined ? String(info[key]) : '';
    };
    location.href.split('?')[1]?.split('&').forEach((v) => {
      const [key, value] = v.split('=');
      if (key && key !== v && info[key] === undefined) {
        info[key] = value;
      }
    });
    // localhost の debug=on 時は、デバッグメニューで保存したトークン・プランを最優先にする
    DebugSession.applyTo(info);

    // デバッグモードが否か
    if ((info.get('debug') === 'on') || (info.get('debug_mode') === 'on')) {
      marietta.WebCADGlobal.DEBUG_MODE = true;
      // デバッグモードにする
      this.setToDebugMode();
    } else {
      marietta.WebCADGlobal.DEBUG_MODE = false;
    }

    // 開発環境 localhost or debug_mode_enabled
    const data = (<HTMLElement>document.querySelector('#website')).getAttribute('data-info');
    const infoFromHTML = JSON.parse(data);
    const isDevelopmentEnvironment = window.location.href.indexOf(LOCAL_HOST_NAME) > -1
      || String(infoFromHTML.debug_mode_enabled) === DEBUG_MODE_ENABLED_VALUE;

    // シェアモード（アカウントを持たないユーザーの起動）の判定
    // 共有リンクのURLとサイト側が保存した起動情報の両方を見るため、それぞれの取得関数を渡す
    // （info.get は両者をマージした値を返すため、判定には使えない）
    const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
    const getUrlParameter = (key: string): string => urlParams.get(key) || '';
    const storedStartupInfo: any = (() => {
      try {
        return JSON.parse(localStorage.getItem(STARTUP_INFO_STORAGE_KEY) || '{}');
      } catch (_) {
        return {};
      }
    })();
    const getStoredParameter = (key: string): string => (storedStartupInfo[key] !== undefined ? String(storedStartupInfo[key]) : '');

    const shareModeManager: marietta.webcad.manager.ShareModeManager = new marietta.webcad.manager.ShareModeManager();
    shareModeManager.initialize(getUrlParameter, getStoredParameter, isDevelopmentEnvironment);
    marietta.webcad.WebCADGlobal.shareModeManager = shareModeManager;

    // モデルのリンクをコピーは、許可された企業の通常起動でのみ表示する（シェアモードではフラグによらず隠す）
    const modelLinkShareFlag: string = info.get(MODEL_LINK_SHARE_FLAG_PARAM_KEY).trim().toLowerCase();
    const canCopyShareLink: boolean = !shareModeManager.isShareMode && MODEL_LINK_SHARE_FLAG_ON_VALUES.includes(modelLinkShareFlag);
    if (!canCopyShareLink) {
      document.getElementById('btnCopyShareLink').closest('li').style.display = 'none';
    }

    // 起動情報取得
    webcad2Dmanager.domain = info.get('api_url');
    webcad2Dmanager.mode = info.get('webcad_data_flag'); // モード1:編集、0：参照
    webcad2Dmanager.zumen_id = info.get('plan_id');
    webcad2Dmanager.article_id = info.get('article_id');
    webcad2Dmanager.division_id = info.get('division_id');
    webcad2Dmanager.plan_name = info.get('plan_name');

    webcad2Dmanager.LiDAR_plan_id = info.get('plan_id');
    if (info.get('operation_type')) {
      webcad2Dmanager.operation_type = info.get('operation_type');
    }
    if (info.get('startup_mode')) {
      webcad2Dmanager.startup_mode = Number(info.get('startup_mode'));
    }
    if (info.get('building_usage_kubun')) {
      webcad2Dmanager.building_usage_kubun = info.get('building_usage_kubun');
    }

    webcad2Dmanager.access_token = info.get('access_token');
    // シェアモードは共有トークンで認証する（各API呼び出しは access_token を参照している）
    if (shareModeManager.usesShareToken) {
      webcad2Dmanager.access_token = shareModeManager.shareTokenAuthorization;
    }
    webcad2Dmanager.lidar_url = info.get('lidar_url');

    // シェアモードは共有ルートのAPIを使う
    // 共有版が用意されていないAPI（groups / article-documents / plan-documents / 更新系）は通常のパスのまま
    const webcadApiPath: string = shareModeManager.usesShareToken ? SHARE_WEBCAD_API_PATH : WEBCAD_API_PATH;

    webcad2Dmanager.get_symbol_construction_codes = `${webcad2Dmanager.domain}${webcadApiPath}/symbol-construction-codes/`;
    webcad2Dmanager.get_grades_api_url = `${webcad2Dmanager.domain}${webcadApiPath}/grades/`;
    webcad2Dmanager.get_grades_item_api_url = `${webcad2Dmanager.domain}${webcadApiPath}/grades/`;
    webcad2Dmanager.get_group_item_api_url = `${webcad2Dmanager.domain}/api/v1/webcad/groups/`;
    webcad2Dmanager.get_symbol_item_api_url = `${webcad2Dmanager.domain}${webcadApiPath}/symbol-items/`;
    webcad2Dmanager.persepective_image_api_url = `${webcad2Dmanager.domain}${webcadApiPath}/parse-image/${webcad2Dmanager.zumen_id}`;
    webcad2Dmanager.get_document_api_url = `${webcad2Dmanager.domain}/api/v1/webcad/article-documents/${webcad2Dmanager.zumen_id}`;
    webcad2Dmanager.get_planning_document_api_url = `${webcad2Dmanager.domain}/api/v1/webcad/plan-documents/${webcad2Dmanager.zumen_id}`;
    marietta.webcad.net.default.param.default.ActionName.UPDATE = `${webcad2Dmanager.domain}/api/v2/webcad/data/${webcad2Dmanager.zumen_id}`;
    marietta.webcad.net.default.param.default.ActionName.GET = `${webcad2Dmanager.domain}${webcadApiPath}/data/${webcad2Dmanager.zumen_id}`;

    // LiDARデーターをサーバーが保持しているか
    webcad2Dmanager.hasLiDAR = info.get("lidar_data_flag") === "1";
    // WebCADデーターをサーバーが保持しているか
    webcad2Dmanager.hasWebCAD = info.get("webcad_data_flag") === "1";
    // 起動情報取得
    webcad2Dmanager.base_url = './';
    webcad2Dmanager.webcad_url = './';
    webcad2Dmanager.cadapi_url = './cadapi/';  //'https://starts-lidar-webcad.marietta.dev/cadapi/';
    const pathUrl = location.origin;

    webcad2Dmanager.assets_3d_url = `${webcad2Dmanager.webcad_url}assets/3d/`;
    webcad2Dmanager.assets_url = `${webcad2Dmanager.webcad_url}assets/`;

    // 開発環境 localhost or debug_mode_enabled
    if (isDevelopmentEnvironment) {
      webcad2Dmanager.webcad_url = './';
      webcad2Dmanager.domain = info.get('api_url') || infoFromHTML.api_url;
      webcad2Dmanager.mode = info.get('webcad_data_flg') || infoFromHTML.webcad_data_flag; // モード1:編集、0：参照
      webcad2Dmanager.zumen_id =  info.get('plan_id') || infoFromHTML.plan_id;
      webcad2Dmanager.article_id = info.get('article_id') || infoFromHTML.article_id;
      webcad2Dmanager.division_id = info.get('division_id') || infoFromHTML.division_id;
      webcad2Dmanager.plan_name = info.get('plan_name') || infoFromHTML.plan_name;
      webcad2Dmanager.LiDAR_plan_id = info.get('plan_id') || infoFromHTML.plan_id;
      webcad2Dmanager.lidar_url = info.get('lidar_url') || infoFromHTML.lidar_url;
      // シェアモードは共有トークンと共有ルートのAPIを使うため、data-infoの値では上書きしない
      if (!shareModeManager.usesShareToken) {
        webcad2Dmanager.access_token = info.get('access_token') || decodeURI(infoFromHTML.access_token).replace('+',' ');
        webcad2Dmanager.get_symbol_construction_codes = infoFromHTML.get_symbol_construction_codes;
        webcad2Dmanager.get_grades_api_url = infoFromHTML.get_grades;
        webcad2Dmanager.get_grades_item_api_url = infoFromHTML.get_grade_item;
        webcad2Dmanager.get_group_item_api_url = infoFromHTML.get_group_item;
        webcad2Dmanager.get_symbol_item_api_url = infoFromHTML.get_symbol_item;
        // デバッグでプランを選んだときだけ、そのプランへ保存する（それ以外は従来どおり HTML の plan_id）
        const perspectivePlanId = DebugSession.hasAppliedPlan() ? webcad2Dmanager.zumen_id : infoFromHTML.plan_id;
        webcad2Dmanager.persepective_image_api_url = `${infoFromHTML.save_parse_image}${perspectivePlanId}`;
      }
      webcad2Dmanager.get_document_api_url = `${webcad2Dmanager.domain}/api/v1/webcad/article-documents/${webcad2Dmanager.zumen_id}`;
      webcad2Dmanager.get_planning_document_api_url = `${webcad2Dmanager.domain}/api/v1/webcad/plan-documents/${webcad2Dmanager.zumen_id}`;
      marietta.webcad.net.default.param.default.ActionName.UPDATE = `${webcad2Dmanager.domain}/api/v2/webcad/data/${webcad2Dmanager.zumen_id}`;
      marietta.webcad.net.default.param.default.ActionName.GET = `${webcad2Dmanager.domain}${webcadApiPath}/data/${webcad2Dmanager.zumen_id}`;
      webcad2Dmanager.hasLiDAR = Number(info.get('lidar_data_flag') || infoFromHTML.lidar_data_flag) === 1;
      webcad2Dmanager.hasWebCAD = Number(info.get('webcad_data_flg') || infoFromHTML.webcad_data_flag) === 1;
      webcad2Dmanager.startup_mode = Number(infoFromHTML.startup_mode);

      // 起動情報取得
      webcad2Dmanager.base_url = './';
      webcad2Dmanager.webcad_url = './';
      webcad2Dmanager.cadapi_url = infoFromHTML.cadapi_url;
    }

    marietta.webcad.WebCADGlobal.webcad2Dmanager = webcad2Dmanager;

    marietta.webcad.WebCADGlobal.masterManager.getGradesMasterData();

    // 共通工事コード
    marietta.webcad.WebCADGlobal.masterManager.getSymbolConstructionCodes();

    // 付帯工事マスタ・修繕理由マスタ
    // シェアモードでは共有ルートに取得APIがなく、値をそのまま表示するため取得しない
    if (!shareModeManager.usesShareToken) {
      marietta.webcad.WebCADGlobal.masterManager.getAuxiliaryMasterData();
      marietta.webcad.WebCADGlobal.masterManager.getRepairMasterData();
    }

    // ユーザーエージェントマネージャー
    const userAgentManager = new marietta.webcad.manager.UserAgentManager();
    marietta.webcad.WebCADGlobal.userAgentManager = userAgentManager;

    // Config情報の取得
    marietta.webcad.WebCADGlobal.webcad2Dmanager.getConfigInfo(() => {
      _main.onConfigLoaded();
    }); // バージョン情報の取得

    marietta.webcad.WebCADGlobal.loadWallDecorationDef();
    marietta.webcad.WebCADGlobal.loadPartsDef();

    // 3Dモードを非表示に
    document.querySelectorAll('.for3D').forEach((element) => {
      (<HTMLElement>element).style.display = 'none';
    });

    (<HTMLElement>document.querySelector('.directionMark')).style.visibility = 'visible';
    if (webcad2Dmanager.mode === '2') {
      // 参照モードへ
      (<HTMLElement>document.querySelector('.directionMark')).style.visibility = 'visible';
      (<HTMLElement>document.querySelector('#itemMenuWrap')).style.display = 'none';
      (<HTMLElement>document.querySelector('#headerMenu2D')).style.display = 'none';
      (<HTMLElement>document.querySelector('#itemControlPanel')).style.display = 'none';
      (<HTMLElement>document.querySelector('#itemChangeMenuWrap')).style.display = 'none';
      (<HTMLElement>document.querySelector('#siteInputMode')).style.display = 'none';
    }
    // スマートフォンタブレット処理
    if (userAgentManager.isMobile || userAgentManager.isTablet) {
      this.spOrTabletInit();
    }

    //オペレーションタイプによって、グレードボタンを非表示にする
    if( webcad2Dmanager.operation_type == 2 ){
      (<HTMLElement>document.querySelector('#headerMenuResetGrade')).style.display = 'none';
    }

    //ラベルの初期化
    marietta.webcad.WebCADGlobal.quotationItemList.initializeListLabel();
  }

  /**
   *  新規作成
   */
  static newPlan = () => {
    // レイヤ－の初期化
    marietta.webcad.WebCADGlobal.layerGroup.initMe();

    // プランIDの初期化
    marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id = null;
    marietta.webcad.WebCADGlobal.webcad2Dmanager.grade = null;
    // フロア表示の初期化処理
    marietta.webcad.WebCADGlobal.onFloorChanged(1);

    // 3Dモデルパラムの初期化
    marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam = null;
    marietta.webcad.WebCADGlobal.autoMain.Model.Init();
    // reset quotationList
    marietta.webcad.WebCADGlobal.quotationItemList.createData();
    // 3D内観カメラ情報の初期化
    marietta.view3d.webcad.View3dGlobal.shared.clearCameraState();

    // 保管
    marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
  };

  /**
   *  GETパラメータを配列にして返す
   *
   *  @return     パラメータのObject
   *
   */
  private getUrlVars = (): any => {
    const vars: any = {};
    const param = location.search.substring(1).split('&');
    for (let i = 0; i < param.length; i++) {
      const keySearch = param[i].search(/=/);
      let key = '';
      if (keySearch != -1) key = param[i].slice(0, keySearch);
      const val = param[i].slice(param[i].indexOf('=', 0) + 1);
      if (key != '') vars[key] = decodeURI(val);
    }
    return vars;
  }

  /**
   * Configの読込が完了した
   */
  private onConfigLoaded = (): void => {
    // enirva.core.debug.Debugger.initialize(document.body);
    const { webcad2Dmanager } = marietta.webcad.WebCADGlobal;

    // ユーザーエージェントマネージャー
    const userAgentManager = new marietta.webcad.manager.UserAgentManager();
    marietta.webcad.WebCADGlobal.userAgentManager = userAgentManager;

    // デバイスごとに表示項目の制限
    marietta.webcad.WebCADGlobal.controlWebCADFuncByUA();

    // Tabletならデバイスの向きを判定してアラートを出す
    if (!userAgentManager.isPC) Main.orderDeviceHorizontally();
    window.addEventListener('orientationchange', () => {
      // eslint-disable-next-line no-shadow
      const { userAgentManager } = marietta.webcad.WebCADGlobal;
      if (!userAgentManager.isPC) Main.orderDeviceHorizontally();
    });

    // アイテムメニューの読み込み
    this.initItemMenu(objItemMenuStair);
    this.initItemMenu(objItemMenuFitting);
    this.initItemMenu(objItemMenuEquipment);
    this.initItemMenu(objItemMenuFurniture, 'FurnitureVariationList');
    this.initItemMenu(objItemMenuExterior);

    // セットアイテム
    const arrayList: any = [objItemMenuEquipment, objItemMenuFurniture, objItemMenuExterior];
    let k;
    let i;
    let n;
    for (n = 0; n < arrayList.length; n += 1) {
      for (i = 0; i < arrayList[n].itemMenuGroup.length; i += 1) {
        for (k = 0; k < arrayList[n].itemMenuGroup[i].children.length; k += 1) {
          if (arrayList[n].itemMenuGroup[i].children[k].id.indexOf('set') > -1) {
            marietta.webcad.WebCADGlobal.LIBRARY_SETITEMS.push(arrayList[n].itemMenuGroup[i].children[k]);
          }
        }
      }
    }

    // アクティベーションチェック後、ライブラリの読込
    if (webcad2Dmanager.userID !== undefined && webcad2Dmanager.userID !== '') {
      const self: Main = this;
      marietta.webcad.WebCADGlobal.activatableCheck(() => { self.initLibrary(); });
    } else {
      // ライブラリの読込
      this.initLibrary();
    }

    // レイヤーの作成
    const layerGroup: marietta.webcad.layer.LayerGroup = new marietta.webcad.layer.LayerGroup();

    // マネージャー
    const itemManager: marietta.webcad.manager.ItemManager = new marietta.webcad.manager.ItemManager();

    // マネージャー
    const scrollerManager: marietta.webcad.manager.ScrollerManager = new marietta.webcad.manager.ScrollerManager(webcad2Dmanager, layerGroup);

    // マネージャー
    const cadAPIManager: marietta.webcad.manager.CadAPIManager = new marietta.webcad.manager.CadAPIManager();

    // マネージャー
    const buildStyleManager: marietta.webcad.manager.BuildStyleManager = new marietta.webcad.manager.BuildStyleManager();

    // マネージャー
    const miniMapManager: marietta.webcad.manager.MiniMapManager = new marietta.webcad.manager.MiniMapManager();

    const planPictManager: marietta.webcad.manager.PlanImageManager = new marietta.webcad.manager.PlanImageManager();

    // マネージャー
    const tabManager: marietta.webcad.manager.TabManager = new marietta.webcad.manager.TabManager();

    // init 3d
    // marietta.webcad.WebCADGlobal.autoMain.autoData = new marietta3d.AutoGen.AutoBase();
    marietta.webcad.WebCADGlobal.autoMain = new marietta3d.manager.AutoMain(new marietta3d.AutoGen.AutoBase());

    // FPSの表示
    // eslint-disable-next-line no-restricted-globals
    if (marietta.webcad.WebCADGlobal.IS_DEMO_MODE || location.hostname === 'localhost') {
      this.statsInit();
    }

    // アイテムメニューの表示切替
    const itemMenuCategories: marietta.webcad.view.ItemMenuCategories = new marietta.webcad.view.ItemMenuCategories();

    // アイテムメニューボタンイベント
    const itemMenu: marietta.webcad.view.ItemMenu = new marietta.webcad.view.ItemMenu(itemManager);

    // アイテムメニューの表示切替3d
    const itemChangeMenuCategories3d: marietta.webcad.view.ItemChangeMenuCategories3d = new marietta.webcad.view.ItemChangeMenuCategories3d();

    // アイテムコントロールパネルイベント
    const itemControlPanel: marietta.webcad.view.ItemControlPanel = new marietta.webcad.view.ItemControlPanel();

    // 2D/3Dボタンイベント
    const dimensionMenu: marietta.webcad.view.DimensionMenu = new marietta.webcad.view.DimensionMenu();

    // モジュール選択コンボボックス（ヘッダーのピッチ入力欄＋寸法モードドロップダウン）イベント
    marietta.webcad.WebCADGlobal.modulePitchCombo = new marietta.webcad.view.ModulePitchCombo();

    marietta.webcad.WebCADGlobal.quotationItemList = new marietta.webcad.view.QuotationItemList();
    //ラベルの初期化
    marietta.webcad.WebCADGlobal.quotationItemList.initializeListLabel();

    // 3D 左メニュー
    const changeHeightMenu: marietta.webcad.view.leftMenu3d.ChangeHeightMenu = new marietta.webcad.view.leftMenu3d.ChangeHeightMenu();
    const roofColorMenu: marietta.webcad.view.leftMenu3d.RoofColorMenu = new marietta.webcad.view.leftMenu3d.RoofColorMenu();
    const roofShapeMenu: marietta.webcad.view.leftMenu3d.RoofShapeMenu = new marietta.webcad.view.leftMenu3d.RoofShapeMenu();
    const outColorMenu: marietta.webcad.view.leftMenu3d.OutColorMenu = new marietta.webcad.view.leftMenu3d.OutColorMenu();
    const sashColorMenu: marietta.webcad.view.leftMenu3d.SashColorMenu = new marietta.webcad.view.leftMenu3d.SashColorMenu();
    const innerColorMenu: marietta.webcad.view.leftMenu3d.InnerColorMenu = new marietta.webcad.view.leftMenu3d.InnerColorMenu();
    const designOptionMenu: marietta.webcad.view.leftMenu3d.DesignOptionMenu = new marietta.webcad.view.leftMenu3d.DesignOptionMenu();
    const innerDesignOptionMenu: marietta.webcad.view.leftMenu3d.InnerDesignOptionMenu = new marietta.webcad.view.leftMenu3d.InnerDesignOptionMenu();

    let threeView;
    // 3D ビュー
    try {
      const data = (<HTMLElement>document.querySelector('#website')).getAttribute('data-info');
      const info = JSON.parse(data);
      threeView = marietta.view3d.webcad.ThreeView.get(document.getElementById('webcad3dView'), info);
      threeView.setupAuto(marietta.webcad.WebCADGlobal.autoMain);
    } catch (e) {
      console.error(e);
    }

    // WebCADGlobalへの登録
    marietta.webcad.WebCADGlobal.itemManager = itemManager;
    marietta.webcad.WebCADGlobal.layerGroup = layerGroup;
    marietta.webcad.WebCADGlobal.scrollerManager = scrollerManager;
    marietta.webcad.WebCADGlobal.cadAPIManager = cadAPIManager;
    marietta.webcad.WebCADGlobal.buildStyleManager = buildStyleManager;
    marietta.webcad.WebCADGlobal.miniMapManager = miniMapManager;
    marietta.webcad.WebCADGlobal.tabManager = tabManager;
    marietta.webcad.WebCADGlobal.itemMenuCategories = itemMenuCategories;
    marietta.webcad.WebCADGlobal.itemMenu = itemMenu;
    marietta.webcad.WebCADGlobal.itemChangeMenuCategories3d = itemChangeMenuCategories3d;
    marietta.webcad.WebCADGlobal.itemControlPanel = itemControlPanel;
    marietta.webcad.WebCADGlobal.dimensionMenu = dimensionMenu;
    marietta.webcad.WebCADGlobal.changeHeightMenu = changeHeightMenu;
    marietta.webcad.WebCADGlobal.roofColorMenu = roofColorMenu;
    marietta.webcad.WebCADGlobal.roofShapeMenu = roofShapeMenu;
    marietta.webcad.WebCADGlobal.outColorMenu = outColorMenu;
    marietta.webcad.WebCADGlobal.sashColorMenu = sashColorMenu;
    marietta.webcad.WebCADGlobal.innerColorMenu = innerColorMenu;
    marietta.webcad.WebCADGlobal.designOptionMenu = designOptionMenu;
    marietta.webcad.WebCADGlobal.innerDesignOptionMenu = innerDesignOptionMenu;
    marietta.webcad.WebCADGlobal.planPictManager = planPictManager;
    marietta.view3d.webcad.View3dGlobal.threeView = threeView;
    marietta.webcad.WebCADGlobal.snapManager = new marietta.webcad.manager.SnapManager();
    marietta.webcad.WebCADGlobal.overlapItemList = new marietta.webcad.view.OverlapItemList();
    marietta.webcad.WebCADGlobal.svgManager = new marietta.webcad.manager.SvgManager();

    // 追加ピン
    const lidarAddPin: marietta.webcad.manager.AddLidarPinManager = new marietta.webcad.manager.AddLidarPinManager();
    marietta.webcad.WebCADGlobal.lidarAddPinManager = lidarAddPin;

    webcad2Dmanager.enableViewMode();


    // AutomainにwebcadUrlをセット
    marietta.webcad.WebCADGlobal.autoMain.setWebcadUrl(webcad2Dmanager.base_url, webcad2Dmanager.webcad_url, webcad2Dmanager.cadapi_url, webcad2Dmanager.assets_url, webcad2Dmanager.assets_3d_url);

    // const newPlan = () => {
    //   // レイヤ－の初期化
    //   marietta.webcad.WebCADGlobal.layerGroup.initMe();

    //   // プランIDの初期化
    //   marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id = null;
    //   marietta.webcad.WebCADGlobal.webcad2Dmanager.grade = null;
    //   // フロア表示の初期化処理
    //   this.onChangeFloor(1);

    //   // 3Dモデルパラムの初期化
    //   marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam = null;
    //   marietta.webcad.WebCADGlobal.autoMain.Model.Init();
    //   // reset quotationList
    //   marietta.webcad.WebCADGlobal.quotationItemList.createData();
    //   // 3D内観カメラ情報の初期化
    //   marietta.view3d.webcad.View3dGlobal.shared.clearCameraState();

    //   // 保管
    //   marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    // };
    /**
     * ボタンイベント一時格納
     */
    document.getElementById('btnNewPlan').addEventListener('click', () => {
      // 配置されているものがなければ無視
      if (marietta.webcad.WebCADGlobal.layerGroup.getAllItems().length <= 0 && marietta.webcad.WebCADGlobal.layerGroup.getAllShitae().length <= 0) return;

      // LiDARデータが存在している場合
      if (marietta.WebCADGlobal.webcad2Dmanager.hasLiDAR == true) {
        const param = { isNewPlan: true };
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.LiDARLogingDialog, false, false, true, true, param);
        return;
      }

      marietta.webcad.WebCADGlobal.showConfirmDialog(marietta.webcad.collection.WebCADMessages.getText('NOTICE_CLOSE_PLAN_AND_NEW'), '', Main.newPlan);
    });
    /**
     * プランの新規作成
     */

    // document.getElementById('btnMeasureLine').addEventListener('click',() => {
    // marietta.webcad.WebCADGlobal.itemManager.drawMeasureLine();
    // });
    //サンプルプランはスターツでは使用しない
    // if (document.getElementById('#btnSampleRead')) {
    //   document.getElementById('btnSampleRead').addEventListener('click', () => {
    //     marietta.webcad.WebCADGlobal.webcad2Dmanager.readSample(1);
    //   });
    // }
    // document.getElementById('btnReadSample1').addEventListener('click', () => {
    //   marietta.webcad.WebCADGlobal.webcad2Dmanager.readSample(1);
    // });
    // document.getElementById('btnReadSample2').addEventListener('click', () => {
    //   marietta.webcad.WebCADGlobal.webcad2Dmanager.readSample(2);
    // });
    // document.getElementById('btnReadSample3').addEventListener('click', () => {
    //   marietta.webcad.WebCADGlobal.webcad2Dmanager.readSample(3);
    // });
    // document.getElementById('btnReadSample4').addEventListener('click', () => {
    //   marietta.webcad.WebCADGlobal.webcad2Dmanager.readSample(4);
    // });


    document.getElementById('menu3dOuter0').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.buildStyleManager.getList();
    });
    document.getElementById('menu3dInner0').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.buildStyleManager.getList();
    });

    if (marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      document.getElementById('checkGroupSelectMode').addEventListener('touchend', Main.btnHeaderGroupSelectModeClickEventHandler);
    }

    document.getElementById('btnSave2').addEventListener('click', Main.saveBtnClickEventHandler);
    document.getElementById('btnSave').addEventListener('click', Main.saveBtnClickEventHandler);

    if (marietta.webcad.WebCADGlobal.userAgentManager.isPC
      || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
      document.getElementById('btnImport').addEventListener('click', () => {
        // 連続して同じファイルを選択できるように初期化
        (<HTMLInputElement>document.getElementById('filePicker')).value = null;
        document.getElementById('filePicker').click();
      });

      document.getElementById('btnExport').addEventListener('click', () => {
        const jsonData: String = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
        marietta.webcad.WebCADGlobal.webcad2Dmanager.exportPlan(jsonData);
      });

      document.getElementById('filePicker').addEventListener('change', (event) => {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.readPlan(event);
      });

      //スターツ不要
      // // 積算情報エキスポートがクリックされた
      // document.getElementById('btnExportSekisan').addEventListener('click', () => {
      //   marietta.webcad.WebCADGlobal.cadAPIManager.getSekisanInfo(marietta.webcad.WebCADGlobal.webcad2Dmanager.exportSekisanData);
      // });
      // 積算情報エキスポートがクリックされた
      // document.getElementById('btnExportJWW').addEventListener('click', () => {
      //   marietta.webcad.WebCADGlobal.webcad2Dmanager.exportPlanJWW();
      // });
      document.getElementById('btnExportDXF').addEventListener('click', () => {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.exportPlanDXF();
      });
      document.getElementById('btnImportPin').addEventListener('click', () => {
        (<HTMLInputElement>document.getElementById('filePickerPIN')).value = null;
        document.getElementById('filePickerPIN').click();
      });

      document.getElementById('filePickerPIN').addEventListener('change', (event) => {
          marietta.webcad.WebCADGlobal.webcad2Dmanager.readPIN(event);
      });

      document.getElementById("btnSvgImgDownload").onclick = (e: MouseEvent) => {
        this.svgImageDownloadEvent();
      };

      // document.getElementById('btnExport').addEventListener('click', () => {
      //   const jsonData: String = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
      //   marietta.webcad.WebCADGlobal.webcad2Dmanager.exportPlan(jsonData);
      // });
    }

      // モデルのリンクをコピー
      document.getElementById('btnCopyShareLink').addEventListener('click', () => {
        Main.copyShareLink();
      });

      // LiDAR読込み
      document.getElementById('btnLiDAR').addEventListener('click', () => {
        ThreeView.get().importLiDAR();
      });

      // file picker（スキャナーアプリの zip を、LiDARデーター読み込みダイアログと同じ流れで読む。json の importLiDARFile は使わない）
      document.getElementById('filePickerLiDAR').addEventListener('change', (event) => {
        const file: File | undefined = (event.target as HTMLInputElement).files?.[0];
        if (file) {
          new LiDARData().fromZip(file);
        }
      });

      document.getElementById('filePickerWebView').addEventListener('change', (event) => {
        ThreeView.get().changeFormat(event);
      });

      // 家の傾きを補正
      document.getElementById('btnCorrection1').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(1);
      });

      // 直線化補正
      document.getElementById('btnCorrection7').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(2);
      });

      // 壁の歪み補正
      document.getElementById('btnCorrection6').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(3);
      });

      // モジュールピッチ補正
      document.getElementById('btnCorrection3').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType == BUILDING_TYPE_HOUSE) {
          ThreeView.get().LidarManager.selectCorrection(4);
        } else {
          ThreeView.get().LidarManager.selectCorrection(14);
        }
      });

      // 短い壁の削除
      document.getElementById('btnCorrection2').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(5);
      });

      // 小さい部屋 補正
      document.getElementById('btnCorrection5').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(6);
      });

      // グリッドに乗せる補正
      document.getElementById('btnCorrection8').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(7);
      });

      // 外周補完
      document.getElementById('btnCorrection4').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(8);
      });

      // 交わる壁の頂点の追加
      document.getElementById('btnCorrection9').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(9);
      });

      // 重なっている独立壁を削除する
      document.getElementById('btnCorrection10').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(10);
      });

      // 軸平行でない独立壁の削除
      document.getElementById('btnCorrection11').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(11);
      });

      // 直線状の点の結合
      document.getElementById('btnCorrection12').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(12);
      });

      // なす角が小さい部屋の削除
      document.getElementById('btnCorrection13').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.selectCorrection(13);
      });

      // 自動補正
      document.getElementById('btnAutoCorrection').addEventListener('click', () => {
        if (!ThreeView.get().LidarManager) return;
        ThreeView.get().LidarManager.autoCorrection();
      });

      // ウィザード開始
      document.getElementById('btnRoomSelect').addEventListener('click', () => {
        ThreeView.get().selectWizard();
      });

      // フォーマット変更
      document.getElementById('btnChangeFormat').addEventListener('click', () => {
        // 連続して同じファイルを選択できるように初期化
        (<HTMLInputElement>document.getElementById('filePickerWebView')).value = null;
        document.getElementById('filePickerWebView').click();
      });

    // 下記機能変更に伴いコメントアウト ボタンをクリックしたら、ダイアログから入力できるよう修正
    // k.kubonaka FireFoxでインポート時にエラー。function()内にeventを追加
    // アイテムを持っている状態
    document.getElementById('pageContainer').addEventListener('dragover', (event) => {
      event.preventDefault();
    });
    document.getElementById('pageContainer').addEventListener('drop', (event) => {
      event.preventDefault();
      return false;
    });

    // ヘッダー選択モードボタン
    document.getElementById('checkSelectMode').addEventListener('click', Main.btnHeaderSelectModeClickEventHandler);

    // ドロップダウンメニューを開く
    document.querySelectorAll('.headerDropdownTrigger').forEach((elem) => {
      elem.addEventListener('click', (e) => {
        e.stopPropagation();
        Main.headerDropdownMode = true;
        const currentInput = (<HTMLButtonElement>(e.currentTarget));
        (<HTMLElement>currentInput.querySelector('.headerDropdownList')).style.display = 'block';
        // document.addEventListener('click', cancelHeaderMenuEvent);
        // eslint-disable-next-line no-unused-expressions
        userAgentManager.isPC
          ? document.addEventListener('click', cancelHeaderMenuEvent)
          : document.addEventListener('touchend', cancelHeaderMenuEvent, { passive: false });
      });
    });
    // ドロップダウンメニューが開いていたら、マウスオーバーで開くドロップダウンを変更
    document.querySelectorAll('.headerDropdownTrigger').forEach((element) => {
      element.addEventListener(userAgentManager.isPC ? 'mouseover' : 'touchstart', (e) => {
        if (Main.headerDropdownMode) {
          document.querySelectorAll('.headerDropdownTrigger').forEach((elem) => {
            (<HTMLElement>elem.querySelector('.headerDropdownList')).style.display = 'none';
          });
          const currentInput = (<HTMLButtonElement>(e.currentTarget));
          (<HTMLElement>currentInput.querySelector('.headerDropdownList')).style.display = 'block';
        }
      });
    });
    // ヘッダーメニューを閉じる
    let cancelHeaderMenuEvent = () => {
      Main.headerDropdownMode = false;
      document.querySelectorAll('.headerDropdownList').forEach((element) => {
        (<HTMLElement>element).style.display = 'none';
      });
      document.querySelectorAll('.headerInnerDropdownList').forEach((element) => {
        (<HTMLElement>element).style.display = 'none';
      });
      // document.removeEventListener('click', cancelHeaderMenuEvent);
      // eslint-disable-next-line no-unused-expressions
      userAgentManager.isPC
        ? document.removeEventListener('click', cancelHeaderMenuEvent)
        : document.removeEventListener('touchend', cancelHeaderMenuEvent);
    };

    // メニューがクリックされたら閉じる
    document.querySelectorAll('.headerDropdownList').forEach((element) => {
      element.addEventListener(userAgentManager.isPC ? 'click' : 'touchend', (e) => {
        e.stopPropagation();
        setTimeout(() => {
          cancelHeaderMenuEvent();
        }, 350);
      });
    });

    // 0.3秒マウスオーバーしたらドロップダウン内のドロップダウンメニュー表示
    let headerDropdownTimer: any;
    document.querySelectorAll('.headerDropdownList').forEach((element) => {
      element.querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('mouseover', (e) => {
          clearTimeout(headerDropdownTimer);
          headerDropdownTimer = setTimeout(() => {
            document.querySelectorAll('.headerDropdownListInner').forEach((el) => {
              (<HTMLElement>el).style.display = 'none';
            });
            if (e.currentTarget) {
              (<HTMLElement>e.currentTarget).querySelectorAll('.headerDropdownListInner').forEach((el) => {
                (<HTMLElement>el).style.display = 'block';
              });
            }
          }, 300);
        });
      });
    });
    document.querySelectorAll('.headerDropdownList').forEach((element) => {
      element.querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('mouseout', () => {
          clearTimeout(headerDropdownTimer);
        });
      });
    });

    // インナードロップダウンがあるときはクリックしても閉じない
    document.querySelectorAll('.headerInnerDropdownTrigger').forEach((element) => {
      element.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });

    // undo redo
    document.getElementById('btnUndo').addEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.undo);
    document.getElementById('btnRedo').addEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.redo);
    document.getElementById('btnUndo2').addEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.undo);
    document.getElementById('btnRedo2').addEventListener('click', marietta.webcad.WebCADGlobal.webcad2Dmanager.redo);

    // リサイズイベント
    window.addEventListener('resize', () => {
      Main.onStageResized();
    });

    // lockall
    document.getElementById('btnLockAll').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.itemManager.lockAll(true);
    });
    document.getElementById('btnUnLockAll').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.itemManager.lockAll(false);
    });

    // 結合ボタン
    if (document.getElementById('btnJoin') != null) {
      document.getElementById('btnJoin').addEventListener('click', () => {
        // オンラインチェック後
        marietta.webcad.WebCADGlobal.checkOnlineAnd(marietta.webcad.WebCADGlobal.cadAPIManager.joinRooms);
      });
    }
    if (document.getElementById('btnJoin2') != null) {
      document.getElementById('btnJoin2').addEventListener('click', () => {
        // オンラインチェック後
        marietta.webcad.WebCADGlobal.checkOnlineAnd(marietta.webcad.WebCADGlobal.cadAPIManager.joinRooms);
      });
    }

    // 面積がクリックされた
    document.getElementById('btnAreaInfo').addEventListener('click', () => {
      // オンラインチェック後
      marietta.webcad.WebCADGlobal.checkOnlineAnd(marietta.webcad.WebCADGlobal.cadAPIManager.getMenseki);
    });

    // 言語ボタンがクリックされた
    document.getElementById('btnLanguage').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.LanguageDialog, true, true);
    });

    // ヘルプがクリックされた
    document.getElementById('btnHelp').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.HelpDialog, false, true, false);
    });

    // 補正しきい値設定がクリックされた
    document.getElementById('btnCorrectionValue').addEventListener('click', () => {
      if (ThreeView.get().correctionManager == null) ThreeView.get().correctionManager = new CorrectionManager(marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType);
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.CorrectionDialog, false, true, false);
    });

    // グレード設定クリック
    document.getElementById('btnGradeReset').addEventListener('click', () => {
      const showGradeDialog = () => {
        let dialog:marietta.webcad.view.dialog.GradeTypeSelectDialog = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.GradeTypeSelectDialog) as marietta.webcad.view.dialog.GradeTypeSelectDialog;
        dialog.callBack = ( grade:GradeMasterCollection, list:any[]　) => {
          //全体に設定
          marietta.webcad.WebCADGlobal.webcad2Dmanager.grade = grade;
          //マスタに更新
          if( list ) marietta.WebCADGlobal.webcad2Dmanager.grade.updateItemList( list );

          const p = new Promise((resolve: Function) => {
            marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_PREPARING_DATA'));
            marietta.webcad.WebCADGlobal.itemManager.setAllItemsToGrade(resolve);
          });
          p.then(() => {
            marietta.webcad.WebCADGlobal.quotationItemList.flushNow(true, true);
            marietta.webcad.WebCADGlobal.hideBusy();

            // 3D表示
            // 2Dの時はグレード選択しても３Dに遷移したくないため条件分岐させる
            if (marietta.webcad.WebCADGlobal.dimensionMenu.mode === "3D") {
              marietta.webcad.WebCADGlobal.dimensionMenu.finished3d();
              marietta.webcad.WebCADGlobal.dimensionMenu.changeMode3D();
            }
          });
        };
      }
      // if (marietta.webcad.WebCADGlobal.webcad2Dmanager.grade) {
      //   marietta.webcad.WebCADGlobal.showConfirmDialog('未設定のアイテムのグレード設定を行います。<br>手入力アイテムはグレード設定でも変更されません', '', () => {
      //     showGradeDialog();
      //   }, () => {
      //   }, false);
      // } else {
      showGradeDialog();
      // }
    });

    // 寸法補正 クリック
    document.getElementById('btnDimensionCorrection').addEventListener('click', this.calibrationCorrection);

    //スターツ版不要
    // // リクエストダイアログを送信する
    // document.getElementById('btnContactUs').addEventListener('click', () => {
    //   marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ContactUsDialog, false, true, false);
    // });

    // document.getElementById('btnRendering').addEventListener('click', (e: MouseEvent) => {

    //   // if( new PSSceneManagement().checkData() == false) {
    //   //     marietta.webcad.WebCADGlobal.showAlert('データー送信(64KB)の最大容量を超えている為、サーバーにアクセス出来ません.');
    //   //     return;
    //   // }
    //   const AWS_Matchmaker = (e) => {
    //     const target = (e.target as HTMLButtonElement);
    //     const NetWorkStatus = ThreeView.get().pscommunication.status;
    //     if (NetWorkStatus == -100) return;
    //     if (NetWorkStatus == network.statustype.unknown || NetWorkStatus == network.statustype.disconnect) {
    //       ThreeView.get().unSelectedObject();
    //       if (NetWorkStatus == network.statustype.unknown){
    //         target.innerHTML = '<span class="jp">接続中</span><span class="en">◎Connecting</span>';
    //       }
    //       // unknown, disconnectならサーバアクセス
    //       ThreeView.get().pscommunication.serverAccess();
    //     } else {
    //       target.innerHTML = '<span class="jp">接続解除</span><span class="en">◎Connecting</span>';
    //       // connectならサーバ接続解除
    //       ThreeView.get().pscommunication.disconnect();
    //     }
    //   }

    //   const isR2M = ThreeView.get().R2MSupport;
    //   if (isR2M) {
    //     ThreeView.get().r2mconnect.execute();
    //   } else {
    //     AWS_Matchmaker(e);
    //   }
    // });

    // 積算情報がクリックされた
    document.getElementById('btnCalculator').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.cadAPIManager.getSekisanInfo();
    });

    document.getElementById('btnCalculator2').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.cadAPIManager.getSekisanInfo();
    });

    document.getElementById('btnOuterWallWidthSetting').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.OuterWallThicknessSettingDialog);
    });

    // // 建具自動生成
    // document.getElementById('btnAutoFitting').addEventListener('click', () => {
    //   // オンラインチェック後
    //   marietta.webcad.WebCADGlobal.checkOnlineAnd(marietta.webcad.WebCADGlobal.itemManager.onGenerateFittingButtonClicked);
    // });
    //
    // document.getElementById('btnAutoFitting2').addEventListener('click', () => {
    //   // オンラインチェック後
    //   marietta.webcad.WebCADGlobal.checkOnlineAnd(marietta.webcad.WebCADGlobal.itemManager.onGenerateFittingButtonClicked);
    // });

    //スターツ不要
    // // 住宅設備 自動生成
    // document.getElementById('btnAutoEquipment').addEventListener('click', () => {
    //   // オンラインチェック後
    //   marietta.webcad.WebCADGlobal.checkOnlineAnd(marietta.webcad.WebCADGlobal.itemManager.onGenerateEquipmentButtonClicked);
    // });
    // document.getElementById('btnAutoEquipment2').addEventListener('click', () => {
    //   // オンラインチェック後
    //   marietta.webcad.WebCADGlobal.checkOnlineAnd(marietta.webcad.WebCADGlobal.itemManager.onGenerateEquipmentButtonClicked);
    // });

    // 廊下自動生成
    document.getElementById('btnAutoHallway').addEventListener('click', () => {
      // オンラインチェック後
      marietta.webcad.WebCADGlobal.checkOnlineAnd(marietta.webcad.WebCADGlobal.itemManager.onGenerateHallwayButtonClicked);
    });

    document.getElementById('btnAutoHallway2').addEventListener('click', () => {
      // オンラインチェック後
      marietta.webcad.WebCADGlobal.checkOnlineAnd(marietta.webcad.WebCADGlobal.itemManager.onGenerateHallwayButtonClicked);
    });

    //梁自動生成
    document.getElementById('btnAutoBeam').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.itemManager.onGenerateBeamButtonClicked();
    });

    // webcadを閉じるボタン
    document.querySelector('#webcadClose > a').addEventListener('click', Main.webcadCloseBtnClickEventHandler);

    // focus解除
    document.getElementById('webcad2dViewInner').addEventListener('mousedown', () => {
      (<HTMLElement>document.activeElement).blur();
    }, true);

    document.getElementById('btnInputCompassDegrees').addEventListener('click', this.onClickInputCompassDegrees);
    document.getElementById('btnInputCompass2Points').addEventListener('click', this.onClickInputCompass2Points);
    if (document.getElementById('btnInputCompassDegrees2'))document.getElementById('btnInputCompassDegrees2').addEventListener('click', this.onClickInputCompassDegrees);
    if (document.getElementById('btnInputCompass2Points2'))document.getElementById('btnInputCompass2Points2').addEventListener('click', this.onClickInputCompass2Points);
    // ピンとアイテムの紐づけウィザード
    document.getElementById('btnAutoIntersectItem')?.addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.showAlert('紐づけたアイテムはリセットされますがよろしいですか？', '', () => {
        const mode3d = new Mode3DTool();
        mode3d.setOption(<optAutoIntersectMode>{ isAutoIntersectMode: true });
        mode3d.start();
      });
    });

    // 表示設定のカスタマイズに使用する機能. グリッドカラー、背景色、squareUnitマージグリッド機能を扱う
    document.getElementById('btnCustomizeDisplay').addEventListener('click', this.btnCustomizeDisplay);

  　//巾木設定
    document.getElementById('btnCustomizeHabaki')?.addEventListener('click', this.btnCustomizeHabaki);


    // 3Dモードでの3DSエクスポートボタン押下時の処理
    if (document.getElementById('btnExport3DS') != null) {
      document.getElementById('btnExport3DS').addEventListener('click', () => {
        const exporter = new marietta.webcad.util.TDSExporter();
        const result = exporter.parse(marietta.view3d.webcad.View3dGlobal.threeView.scene.me);

        const blob = new Blob([result], { type: 'application/octet-stream' });
        const filename = 'test.3ds';

        const link = document.createElement('a');
        link.style.display = 'none';

        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      });
    }

    // gltf exporter
    if (document.getElementById('btnGltfExport') != null) {
      document.getElementById('btnGltfExport').addEventListener('click', () => {
        ThreeView.get().export_gltf();
      });
    }

    // glb exporter (cadapi)
    if (document.getElementById('btnGLBExport') != null) {
      document.getElementById('btnGLBExport').addEventListener('click', () => {
        ThreeView.get().export_glb();
      });
    }

    // scene.extras exporter
    if (document.getElementById('btnJSONExport') != null) {
      document.getElementById('btnJSONExport').addEventListener('click', () => {
        ThreeView.get().export_extras();
      });
    }

    // 最初の画面ページローダー削除
    // this.handleFirstPageLoader();

    // ステージのリサイズ
    Main.onStageResized();
    document.addEventListener('keydown', marietta.webcad.WebCADGlobal.webcad2Dmanager.onKeyDown);
    document.addEventListener('keyup', marietta.webcad.WebCADGlobal.webcad2Dmanager.onKeyUp);

    document.getElementById('snapPitchList').addEventListener('change', (e: Event) => {
      _main.changeSnapUnit(e);
    });
    // ※モジュール選択コンボボックスのイベント配線は marietta.webcad.view.ModulePitchCombo のコンストラクタで行う

    // アイテムガイドの表示

    document.getElementById('btnGuideLine').addEventListener('click', () => {
      // 表示・非表示の切り替え
      marietta.webcad.WebCADGlobal.webcad2Dmanager.guideVisible = !marietta.webcad.WebCADGlobal.webcad2Dmanager.guideVisible;
    });
    document.getElementById('checkGuideLine')?.addEventListener('click', () => {
      // 表示・非表示の切り替え
      marietta.webcad.WebCADGlobal.webcad2Dmanager.guideVisible = !marietta.webcad.WebCADGlobal.webcad2Dmanager.guideVisible;
    });
    document.getElementById('btnPin').addEventListener('click', () => {
      // 表示・非表示の切り替え
      marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible = !marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible;
      marietta.webcad.WebCADGlobal.itemManager.showOrHidePin();
    });
    document.querySelectorAll(PIN_TOGGLE_BUTTON_SELECTOR).forEach((element) => {
      element.addEventListener('click', () => {
        // 表示・非表示の切り替え
        marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible = !marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible;
        marietta.webcad.WebCADGlobal.itemManager.showOrHidePin();
      });
    });
    document.getElementById('checkPin2').addEventListener('click', () => {
      // 表示・非表示の切り替え
      marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible = !marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible;
      marietta.webcad.WebCADGlobal.itemManager.showOrHidePin();
    });

    if (localStorage.getItem('guide')) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.guideVisible = (Boolean(parseInt(localStorage.getItem('guide'), 10)));
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.guideVisible = true;
    }

    if (localStorage.getItem('pin')) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible = (Boolean(parseInt(localStorage.getItem('pin'), 10)));
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.pinVisible = true;
    }

    if (localStorage.getItem('size')) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement = (Boolean(parseInt(localStorage.getItem('size'), 10)));
      marietta.webcad.WebCADGlobal.webcad2Dmanager.updateBtnSunpousen(!marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement);
    } else {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement = true;
      marietta.webcad.WebCADGlobal.webcad2Dmanager.updateBtnSunpousen(!marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement);
    }

    // 寸法線がクリックされた
    document.getElementById('btnMeasureLine').addEventListener('click', () => {
      // オンラインチェック後
      if ((<HTMLElement>document.querySelector('.btnNameOn')).style.display === 'none') {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement = false;
      } else {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement = true;
      }
      marietta.webcad.WebCADGlobal.checkOnlineAnd(marietta.webcad.WebCADGlobal.itemManager.drawMeasureLine);
      marietta.webcad.WebCADGlobal.itemManager.showOrHideMeasureLine();
    });
    document.querySelectorAll(MEASURE_LINE_TOGGLE_BUTTON_SELECTOR).forEach((element) => {
      element.addEventListener('click', () => {
        // 表示・非表示の切り替え
        marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement = !marietta.webcad.WebCADGlobal.webcad2Dmanager.displayLineMeasurement;
        marietta.webcad.WebCADGlobal.checkOnlineAnd(marietta.webcad.WebCADGlobal.itemManager.drawMeasureLine);
        marietta.webcad.WebCADGlobal.itemManager.showOrHideMeasureLine();
        marietta.webcad.WebCADGlobal.itemManager.showCurrentItemMeasureLine();
      });
    });

    // リスト表示アニメーション
    document.getElementById('btnShowQuotation').onclick = () => {
      const style = window.getComputedStyle(document.getElementById('footerMenuQuotationList'));
      const matrix = new WebKitCSSMatrix(style.transform);
      let isMenuOpen = false;
      if (matrix.m42 !== 15) {
        document.getElementById('footerMenuQuotationList').style.transform = `translate(${matrix.m41}px, 15px)`;
        isMenuOpen = true;
      } else {
        document.getElementById('footerMenuQuotationList').style.transform = `translate(${matrix.m41}px, calc(100% - 18px))`;
      }
      marietta.webcad.WebCADGlobal.quotationItemList.footerListOpen = isMenuOpen;
    };
  }

  /**
     * SVG画像のダウンロード
     */
  private svgImageDownloadEvent() {
    const p = new Promise((resolve: Function, reject: Function) => {
      marietta.webcad.WebCADGlobal.showBusy();
      marietta.webcad.WebCADGlobal.svgManager.exportFloorImage(resolve);
    });
    p.then((svgEl: SVGElement) => {
      marietta.webcad.WebCADGlobal.hideBusy();
    }).catch((msg: any) => {
      marietta.webcad.WebCADGlobal.hideBusy();
    });
  }

  /**
   * 寸法補正
   * キャリブレーション機能
   * @returns
   */
  private calibrationCorrection = () => {
    if (!marietta.webcad.WebCADGlobal.hasRoomInput()) {
      marietta.webcad.WebCADGlobal.showAlert('間取りを入力してください');
      return;
    }

    const calibrationWall = () => { // キャリブレーション機能実行
      (<HTMLElement>document.querySelector('.calibrationWallGuide')).style.display = 'block';
      marietta.webcad.WebCADGlobal.itemManager.editRooms('calibrationWall');
    }

    // 外壁厚の設定が0かどうかチェック
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.outerWallThickness != 0) {
      const okFunc = () => {
        // 外壁厚を0に設定
        marietta.webcad.WebCADGlobal.webcad2Dmanager.outerWallThickness = 0;
        marietta.webcad.WebCADGlobal.cadAPIManager.MakeRoomWall();
        marietta.webcad.WebCADGlobal.updateMeasureLine(false, false);
        calibrationWall();
      }

      marietta.webcad.WebCADGlobal.showConfirmDialog(marietta.webcad.collection.WebCADMessages.getText('OUTERWALL_INIT'), '', okFunc);
      return;
    }

    calibrationWall();
  }

  // /**
  //  * 最初のページ画面を処理する関数
  // * */
  // private handleFirstPageLoader = () => {
  //   this.fadeOut();
  //   this.fadeIn();
  //   setTimeout(() => {
  //     document.getElementById('firstPageLoader').remove();
  //   }, 5000);
  // }

  /**
   * 最初のページ画面を処理する関数
   * */
  private handleFirstPageLoader = () => {
    $('#firstPageLoader').fadeOut(1000);
    $('#pageBodyLoader').fadeIn(1000);
    setTimeout(() => {
      $('#firstPageLoader').remove();
    }, 5000);
  } // todo: remove jQuery

  // private fadeIn = () => {
  //   const fade = document.getElementById('pageBodyLoader');
  //   let opacity = 0;
  //   const intervalID = setInterval(() => {
  //     if (opacity < 1) {
  //       opacity += 0.5;
  //       fade.style.opacity = String(opacity);
  //     } else {
  //       clearInterval(intervalID);
  //     }
  //   }, 1000);
  // }

  // private fadeOut = () => {
  //   const fade = document.getElementById('firstPageLoader');
  //   let opacity = 1;
  //   const intervalID = setInterval(() => {
  //     if (opacity > 0) {
  //       opacity -= 0.4;
  //       fade.style.opacity = String(opacity);
  //     } else {
  //       clearInterval(intervalID);
  //     }
  //   }, 1000);
  // }

  /**
   * 階数変更
   * @param 階数
   */
  private onChangeFloor = (floor: number): void => {
    marietta.webcad.WebCADGlobal.overlapItemList.hideList();
    // 階が違う場合はアイテムを削除
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor !== floor) {
      // currentActionModeを変更
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    }
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor = floor;
    (<HTMLInputElement>document.querySelectorAll('input[name=currentFloor2d]')[floor - 1]).checked = true;
    // メニューの禁止項目制御
    if (floor === 1) {
      _main.changeActivenessExterior(true);
      _main.changeActiveness(true);
      _main.changeActivenessStair(true);
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentModeNo === ITEM_MODE_NO.MODE_SITE_NO) {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE;
      }
    } else {
      // 入力を蓮しておく。
      if (document.getElementById('btnMakeSite')) {
        (<HTMLInputElement>document.getElementById('btnMakeSite')).checked = false;
      }

      _main.changeActivenessExterior(false);
      _main.changeActiveness(false);
      if (floor === 3) {
        _main.changeActivenessStair(false);
      } else {
        _main.changeActivenessStair(true);
      }
    }

    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
      marietta.webcad.WebCADGlobal.snapManager.updateSnapElements();
    }
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList();
    // 寸法線幅更新
    // (marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor).layer_measure as marietta.webcad.layer.MeasureLayer).measureLineStrokeUpdate();
  }

  /**
   * メニューdisable制御
   * @param 階数
   */
  private changeActivenessExterior = (bool: boolean): void => {
    if (bool) {
      document.querySelector('#exterior.itemMenuGroup').querySelectorAll('button').forEach((element) => {
        element.style.opacity = '1';
        element.style.cursor = 'pointer';
        element.removeAttribute('disabled');
      });
    } else {
      document.querySelector('#exterior.itemMenuGroup').querySelectorAll('button').forEach((element) => {
        element.style.opacity = '0.2';
        element.style.cursor = 'not-allowed';
        element.setAttribute('disabled', 'disabled');
      });
    }
  }

  private changeActivenessStair = (bool: boolean) => {
    if (bool) {
      document.querySelector('#stair.itemMenuGroup').querySelectorAll('button').forEach((element) => {
        element.style.opacity = '1';
        element.style.cursor = 'pointer';
        element.removeAttribute('disabled');
      });
    } else {
      document.querySelector('#stair.itemMenuGroup').querySelectorAll('button').forEach((element) => {
        element.style.opacity = '0.2';
        element.style.cursor = 'not-allowed';
        element.setAttribute('disabled', 'disabled');
      });
    }
  }

  private changeActiveness = (bool: boolean): void => {
    if (bool) {
      document.querySelector('#roomVariation_rom01_01 + label').classList.remove('notAllowed');
      document.querySelector('#roomVariation_rom01_01 + label').removeEventListener('click', this.preventEvents);

      document.querySelector('#roomVariation_rom27_01 + label').classList.remove('notAllowed');
      document.querySelector('#roomVariation_rom27_01 + label').removeEventListener('click', this.preventEvents);

      document.querySelector('#roomVariation_rom18_01 + label').classList.add('notAllowed');
      document.querySelector('#roomVariation_rom18_01 + label').addEventListener('click', this.preventEvents);

      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
        document.querySelector('#roomVariation_rom18_01 + label').classList.remove('notAllowed');
        document.querySelector('#roomVariation_rom18_01 + label').removeEventListener('click', this.preventEvents);
      }

      document.querySelector('#roomVariation_rom17_01 + label').classList.add('notAllowed');
      document.querySelector('#roomVariation_rom17_01 + label').addEventListener('click', this.preventEvents);
    } else {
      document.querySelector('#roomVariation_rom01_01 + label').classList.add('notAllowed');
      document.querySelector('#roomVariation_rom01_01 + label').addEventListener('click', this.preventEvents);

      document.querySelector('#roomVariation_rom27_01 + label').classList.add('notAllowed');
      document.querySelector('#roomVariation_rom27_01 + label').addEventListener('click', this.preventEvents);

      document.querySelector('#roomVariation_rom18_01 + label').classList.remove('notAllowed');
      document.querySelector('#roomVariation_rom18_01 + label').removeEventListener('click', this.preventEvents);

      document.querySelector('#roomVariation_rom17_01 + label').classList.remove('notAllowed');
      document.querySelector('#roomVariation_rom17_01 + label').removeEventListener('click', this.preventEvents);
    }
  }

  private preventEvents = (e: Event): boolean => {
    e.preventDefault();
    return false;
  }

  /**
   * スナップ単位の変更
   */
  private changeSnapUnit(event: any): void {
    const unit = Number(event.target.value);

    // 元のスナップよりも大きい場合はアラート表示
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnit < unit && marietta.webcad.WebCADGlobal.layerGroup.getAllItems().length > 0) {
      marietta.webcad.WebCADGlobal.showConfirmDialog('グリッドを変更後に部屋や建具を選択すると、位置がずれる場合があります。<br>ご注意ください。<br>グリッドを変更しますか？', '', this.onConfirmCheck_ok, this.onConfirmCheck_no, false);
    } else {
      // 適用を実施する
      this.onConfirmCheck_ok();
    }
  }

  /**
   * スナップ単位の変更＿OK
   */
    // eslint-disable-next-line camelcase
  private onConfirmCheck_ok = (): void => {
    const unit =(<HTMLInputElement>document.getElementById('snapPitchList')).value;
    marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnit = (unit=='off') ? unit : Number(unit);
  }

  /**
   * スナップ単位の変更＿NG
   */
    // eslint-disable-next-line camelcase
  private onConfirmCheck_no = (): void => {
    // 元に戻す
    (<HTMLInputElement>document.getElementById('snapPitchList')).value = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnit.toString();
  }

  /**
   * アイテムメニューの読込＆準備
   */
  private initItemMenu = (obj: any, variationListName: string = ''): void => {
    const $target = document.querySelector(obj.targetID);

    // カテゴリーの追加
    if (variationListName) {
      const header = document.querySelector(`${obj.targetID} .itemMenuHeader .itemMenuFuncBtns`);
      const select = document.createElement('select');
      select.classList.add('jp');
      select.classList.add('categorySelect');
      select.id = `Category${variationListName}`;
      const selectEn = document.createElement('select');
      selectEn.classList.add('en');
      selectEn.classList.add('categorySelect');
      selectEn.id = `Category${variationListName}`;

      obj.variationList.forEach((category) => {
        // カテゴリーの追加
        if (header) {
          const option = document.createElement('option');
          option.innerHTML = `<span>${category.text}</span>`;
          option.value = category.value;
          option.setAttribute('data-id', category.value);
          select.appendChild(option);
          const optionEn = document.createElement('option');
          optionEn.innerHTML = `<span>${category.text_en}</span>`;
          optionEn.value = category.value;
          optionEn.setAttribute('data-id', category.value);
          selectEn.appendChild(optionEn);
        }
      });
      header.appendChild(select);
      header.appendChild(selectEn);
    }

    // メニューの追加
    for (let i = 0; i < obj.itemMenuGroup.length; i += 1) {
      const el: Element = document.createElement('div');
      el.setAttribute('id', obj.itemMenuGroup[i].id);
      el.classList.add('itemMenuBtns');
      for (let j = 0; j < obj.itemMenuGroup[i].children.length; j += 1) {
        const elBtn = document.createElement('button');
        const span1 = document.createElement('span');
        span1.setAttribute('class', 'jp');
        const span2 = document.createElement('span');
        span2.setAttribute('class', 'en');

        const elImg = document.createElement('img');
        const elImgEn = document.createElement('img');

        elBtn.setAttribute('id', obj.itemMenuGroup[i].children[j].id);
        if (Object.prototype.hasOwnProperty.call(obj.itemMenuGroup[i].children[j], 'dataItemWidth')) {
          elBtn.setAttribute('data-item_width', obj.itemMenuGroup[i].children[j].dataItemWidth);
        }
        if (Object.prototype.hasOwnProperty.call(obj.itemMenuGroup[i].children[j], 'dataItemDepth')) {
          elBtn.setAttribute('data-item_depth', obj.itemMenuGroup[i].children[j].dataItemDepth);
        }
        if (Object.prototype.hasOwnProperty.call(obj.itemMenuGroup[i].children[j], 'dataItemWidthmm')) {
          elBtn.setAttribute('data-item_widthmm', obj.itemMenuGroup[i].children[j].dataItemWidthmm);
        }
        if (Object.prototype.hasOwnProperty.call(obj.itemMenuGroup[i].children[j], 'dataItemDepthmm')) {
          elBtn.setAttribute('data-item_depthmm', obj.itemMenuGroup[i].children[j].dataItemDepthmm);
        }
        if (Object.prototype.hasOwnProperty.call(obj.itemMenuGroup[i].children[j], 'dataItemFittingHeight')) {
          elBtn.setAttribute('data-item_fitting_height', obj.itemMenuGroup[i].children[j].dataItemFittingHeight);
        }
        elBtn.classList.add('itemMenuBtn');

        elImg.setAttribute('src', marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url + obj.itemMenuGroup[i].children[j].img);
        elImg.setAttribute('alt', obj.itemMenuGroup[i].children[j].name);
        elImgEn.setAttribute('src', marietta.webcad.WebCADGlobal.webcad2Dmanager.webcad_url + obj.itemMenuGroup[i].children[j].img_en);
        elImgEn.setAttribute('alt', obj.itemMenuGroup[i].children[j].name_en);

        marietta.webcad.WebCADGlobal.LIBRARY_ITEMSLIST.set(obj.itemMenuGroup[i].children[j].id,
          {
            width: obj.itemMenuGroup[i].children[j].dataItemWidth,
            widthmm: obj.itemMenuGroup[i].children[j].dataItemWidthmm,
            height: obj.itemMenuGroup[i].children[j].dataItemDepth,
            heightmm: obj.itemMenuGroup[i].children[j].dataItemDepthmm,
            fitting_height: obj.itemMenuGroup[i].children[j].dataItemFittingHeight,
            name: obj.itemMenuGroup[i].children[j].name,
            name_en: obj.itemMenuGroup[i].children[j].name_en,
          });
        span1.appendChild(elImg);
        span2.appendChild(elImgEn);

        elBtn.appendChild(span1);
        el.appendChild(elBtn);
        elBtn.appendChild(span2);
        el.appendChild(elBtn);

        // 複数カテゴリ持ちは非表示にする
        if (obj.itemMenuGroup[i].children[j].isMultiCategory) {
          elBtn.style.display = 'none';
          elBtn.classList.add('isMultiCategory');
        }
      }
      $target.querySelectorAll('.itemMenuGroup').forEach((element) => {
        element.appendChild(el);
      });
    }

    //特別固定メニュー（2Dメニューに配置したくないアイテム）
    marietta.webcad.WebCADGlobal.LIBRARY_ITEMSLIST.set("fur52_01",
      {
        width: "500",
        widthmm: "500",
        height: "500",
        heightmm: "500",
        name: "ペンダントライト",
        name_en: "Light",
      });
  }

  /**
   * ライブラリの読込＆準備
   */
  private initLibrary(): void {
    // svg プリロード
    // 外部svg呼び出し
    const svglist = [
      { name: 'icon_delete.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'icon_garbage.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'icon_reverse.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'icon_setting.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'icon_replace.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'control_dragger.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'control_room_dragger.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'control_rotater.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'icon_pen.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'icon_pen_addPoint.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'compass.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'icon_crosshair.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'control_pintext.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'control_pinpicture.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
      { name: 'control_pinpanorama.svg', basePath: `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/` },
    ];
    let itemLibs = '<div></div>';
    for (let i = 0, len = svglist.length; i < len - 1; i += 1) {
      itemLibs += '<div></div>';
    }
    document.getElementById('svgContainer').innerHTML = itemLibs;
    for (let i = 0, len = document.querySelectorAll('#svgContainer div').length; i < len; i += 1) {
      const idName = `lib_${svglist[i].name.split('.svg')[0]}`;
      const svgPath = svglist[i].basePath + svglist[i].name;
      document.querySelectorAll('#svgContainer div')[i].setAttribute('id', idName);
      fetch(svgPath)
        .then((data) => data.text())
        .then((data) => {
          document.querySelectorAll('#svgContainer div')[i].innerHTML = data;
        });
    }

    Master.initialize(this.initialize, this);
  }

  private initialize(): void {
    // ステージのマウス座標監視用
    Stage.initialize();
    marietta.webcad.WebCADGlobal.layerGroup.initialize();

    // cadAPI version
    const url = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.cadapi_url}api/check_version`;
    const xhttp = new XMLHttpRequest();
    // eslint-disable-next-line func-names
    xhttp.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        // let data = JSON.parse(this.response);
        if (this.response != null) {
          marietta.webcad.WebCADGlobal.API_VERSION = this.response.cadapi_version;
          console.log(marietta.webcad.WebCADGlobal.API_VERSION);
        }
      }
    };
    xhttp.addEventListener('error', (evt) => {
      console.log(evt);
    });
    xhttp.responseType = 'json';
    xhttp.open('GET', url, true);

    xhttp.send();

    // レイヤーの位置の初期化
    marietta.webcad.WebCADGlobal.scrollerManager.controlLayerEnlargementFit();

    // // アイテムメニュー初期表示
    // marietta.webcad.WebCADGlobal.itemMenu.initView();

    // 方位マーク
    const siteCompass = new marietta.webcad.item.parts.Compass();
    marietta.webcad.WebCADGlobal.siteCompass = siteCompass;

    // ローディングビジー非表示
    marietta.webcad.WebCADGlobal.hideBusy();

    // フロア表示初期化
    this.onChangeFloor(1);

    // 一定時間操作がなかったらヘルプメッセージを表示する
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (!ua.isMobile && !ua.isTablet) Main.setHelpMsgByTimer();

    // pad,mobileメニュー初期設定
    Main.initMenuforPadAndMobile();

    // プランの読込
    // if (!isNaN(marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id)) {
    //     marietta.webcad.WebCADGlobal.webcad2Dmanager.loadPlan();
    // } else {
    //     marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    //     //お部屋入力モードに変更する
    //     let menu = document.getElementById("itemMenu_room");
    //     menu.click();
    // }

    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id !== null && marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id !== undefined && marietta.webcad.WebCADGlobal.webcad2Dmanager.zumen_id !== '') {
      // 参照モードは、ログインチェックを行わず、プランの読込を行う
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.mode === '0') {
        // お部屋入力モードに変更する（シェアモードは閲覧のみのため入力モードにしない）
        if (!marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) {
          const menu = document.getElementById('itemMenu_room');
          menu.click();
        }

        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.hasLiDAR == false) {
          // 新規作成かつ戸建てモード・マンションモードの設定がない場合はモード設定ダイアログを表示する(パフォーマンスチェック時はスキップ)
          if (Number.isNaN(Number(marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType)) && localStorage.getItem('notShowPerformance') === '1') {
            Main.setBuildingStyleFromQueryParameterCondition();
          }

        } else {
          if (localStorage.getItem('notShowPerformance') === '1' && marietta.webcad.WebCADGlobal.webcad2Dmanager.hasWebCAD == false) { //パフォーマンスチェックがOFF
            if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isViewMode()) {
              marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.LiDARLogingDialog);
            }
          } else {
            // 新規作成かつ戸建てモード・マンションモードの設定がない場合はモード設定ダイアログを表示する(パフォーマンスチェック時はスキップ)
            if (Number.isNaN(Number(marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType)) && localStorage.getItem('notShowPerformance') === '1') {
              Main.setBuildingStyleFromQueryParameterCondition();
            }
          }
          // new LiDARData().json();
        }
      } else {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.checkIfLoginAnd(marietta.webcad.WebCADGlobal.webcad2Dmanager.loadPlan);
      }
    } else {
      // シェアモードは閲覧のみのため、入力モードにしない
      if (!marietta.webcad.WebCADGlobal.webcad2Dmanager.isViewMode() && !marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) {
        // お部屋入力モードに変更する
        const menu = document.getElementById('itemMenu_room');
        menu.click();
        if (marietta.WebCADGlobal.DEBUG_MODE && (location.href.indexOf('localhost') > -1)) {    // デバッグモード＆ローカル
          //起動用暫定処理--------------------------↓
          // 建築モードの更新
          marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = 0;
          // アイテムメニュー初期表示
          marietta.webcad.WebCADGlobal.itemMenu.initView();
          //起動用暫定処理--------------------------↑

          if (marietta.webcad.WebCADGlobal.webcad2Dmanager.hasLiDAR == true && marietta.webcad.WebCADGlobal.webcad2Dmanager.hasWebCAD == false) {
            marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.LiDARLogingDialog);
            // new LiDARData().json();
          }
        } else {
          // 新規作成かつ戸建てモード・マンションモードの設定がない場合はモード設定ダイアログを表示する(パフォーマンスチェック時はスキップ)
          if (Number.isNaN(Number(marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType)) && localStorage.getItem('notShowPerformance') === '1') {
            marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.BuildingTypeSelectDialog, false, true, false);
          }
        }
      }
    }

    // シェアモードは閲覧のみのため、アイテムを選択するだけのモードで起動する
    if (marietta.webcad.WebCADGlobal.shareModeManager.isShareMode) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM;
    }

    // 変更フラグがたってしまうので下ろす
    marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = false;

    // デモモードの場合は、アラートを表示する
    if (marietta.webcad.WebCADGlobal.IS_DEMO_MODE) {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('DEMOMODE_ERROR_MESSAGE'), marietta.webcad.collection.WebCADMessages.getText('DEMOMODE_ERROR_TITLE'));
    } else {
      // $('.js-notForDemo').remove();
    }

    // PC以外で、かつiOS8以下であれば警告
    if (ua.isiOS && Number(ua.iOSversion) < 900) {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('IOS_ERROR_MESSAGE'), marietta.webcad.collection.WebCADMessages.getText('IOS_ERROR_TITLE'));
    }

    if (ua.isSafari && ua.isPC) {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('SAFARI_ERROR_MESSAGE'), marietta.webcad.collection.WebCADMessages.getText('SAFARI_ERROR_TITLE'));
    }

    // Firefoxは非対応
    /* if (ua.isFirefox) {
            marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText("FIREFOX_ERROR_MESSAGE"), marietta.webcad.collection.WebCADMessages.getText("FIREFOX_ERROR_TITLE"));
        } */

    // メニューボタン群の更新
    marietta.webcad.WebCADGlobal.itemMenuCategories.updateItemMenuButtons();
    // 最初の画面ページローダー削除
    this.handleFirstPageLoader();
  }

  /**
   * 建物タイプをクエリパラメータに応じて変更する
   */
  static setBuildingStyleFromQueryParameterCondition():void {
    // 起動パラメータ（建物用途）
    const paramMode:string = marietta.webcad.WebCADGlobal.webcad2Dmanager.building_usage_kubun;
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.isViewMode()) {
      return;
    }

    // 指定がなければ、ダイアログを表示する
    if (paramMode == null || paramMode == undefined || isNaN(parseInt(paramMode))) {
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.BuildingTypeSelectDialog, false, true, false);
      return;
    }
    let selectedMode:number = parseInt(paramMode);
    // サイトで使っているIDと差があるので、補正
    selectedMode -= 1;
    // 建築モードの更新
    marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType = selectedMode;
    if (selectedMode === BUILDING_TYPE_MANSION) {
      (<HTMLInputElement>document.getElementById('btnRoomDragInput')).checked = false;
      (<HTMLInputElement>document.getElementById('btnRoomKakomiInput')).checked = true;
      marietta.webcad.WebCADGlobal.changeFloor(1);
    }
    // アイテムメニュー初期表示
    marietta.webcad.WebCADGlobal.itemMenu.initView();
  }

  // メニュー初期設定（パッド用）
  static initMenuforPadAndMobile() {
    if (marietta.webcad.WebCADGlobal.userAgentManager.isPC) return;
    // 部屋メニュー種類（ラジオボタン）のデフォルトのチェックをはずす
    // document.getElementById('roomInputMenuItems').querySelectorAll('input[type="radio"]').forEach((element) => {
    //   (<HTMLInputElement>element).checked = true;
    // });
    if (document.getElementById('btnJoin2') != null) {
      document.getElementById('btnJoin2').querySelectorAll('li').forEach((element) => {
        element.remove();
      });
    }
  }

  /**
   * タブレット時、縦向きならアラートを表示
   */
  static orderDeviceHorizontally(): void {
    const DEVICE_LANDSCAPE: number = 1;
    const DEVICE_PORTRAIT: number = 0;
    const $target = (<HTMLElement>document.getElementById('device_orientation'));
    // eslint-disable-next-line camelcase
    const device_orientation = () => {
      if (typeof window.orientation !== 'undefined') {
        return Math.abs(Number(window.orientation)) === 90 ? DEVICE_LANDSCAPE : DEVICE_PORTRAIT;
      }
      return (window.innerWidth < window.innerHeight ? DEVICE_PORTRAIT : DEVICE_LANDSCAPE);
    };
    switch (device_orientation()) {
      case DEVICE_LANDSCAPE: $target.style.display = 'none'; break;
      case DEVICE_PORTRAIT: $target.style.display = 'block'; break;
      default: break;
    }
  }

  /**
   * ステージのリサイズがされた
   */
  static onStageResized(): void {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    // レイヤーの大きさの設定 2D
    const width = Math.round(document.body.clientWidth - marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH);
    const height = Math.round(window.innerHeight - document.getElementById('header').offsetHeight - document.getElementById('footer').offsetHeight);
    let renderableHeight = height;
    let renderableWidth = width;
    if (width > height) {
      renderableWidth = width;
      renderableHeight = Math.round(renderableWidth * (9 / 16));
      if(renderableHeight < height) {
        renderableHeight = height;
        renderableWidth = Math.round(renderableHeight * (16 / 9));
      }
    } else if (width < height) {
      renderableHeight = height;
      renderableWidth = Math.round(renderableHeight * (16 / 9));
      if (width > renderableWidth) {
        renderableWidth = width;
        renderableHeight = Math.round(renderableWidth * (9 / 16));
      }
    }
    const x = Math.abs((width-renderableWidth)/2);
    const y = Math.abs((height-renderableHeight)/2);
    // console.log('renderableWidth', renderableWidth);
    // console.log('renderableHeightr', renderableHeight);
    document.getElementById('webcad3dView').style.width = `${String(renderableWidth)}px`;

    document.getElementById('webcad3dView').style.height = `${String(renderableHeight)}px`;

    document.getElementById('webcad3dView').style.top = `${String(-1*y)}px`;
    document.getElementById('webcad3dView').style.left = `${String(-1*x)}px`;

    document.getElementById('webcad2dView').style.width = `${String(document.body.clientWidth - marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH)}px`;
    document.getElementById('webcad3dViewWrapper').style.width = `${String(width)}px`;
    if (ua.isMobile || ua.isTablet) {
      document.getElementById('webcad2dView').style.height = `${String(window.innerHeight - document.getElementById('header').offsetHeight - document.getElementById('footer').offsetHeight)}px`;
      document.getElementById('itemMenuWrap').style.height = `${String(document.querySelector('#webcad2dViewInner').clientHeight)}px`;
      document.getElementById('itemChangeMenuWrap').style.height = `${String(document.documentElement.clientHeight - document.getElementById('header').offsetHeight - document.getElementById('footer').offsetHeight)}px`;
    } else {
      document.getElementById('webcad2dView').style.height = `${String(window.innerHeight - document.getElementById('header').offsetHeight - document.getElementById('footer').offsetHeight)}px`;
      document.getElementById('itemMenuWrap').style.height = `${String(document.querySelector('#webcad2dViewInner').clientHeight)}px`;
      document.getElementById('itemChangeMenuWrap').style.height = `${String(document.documentElement.clientHeight - document.getElementById('header').offsetHeight - document.getElementById('footer').offsetHeight)}px`;
    }
    // レイヤーの大きさの設定 3D
    if (ua.isMobile || ua.isTablet) {
      document.getElementById('webcad3dViewWrapper').style.height = `${String(window.innerHeight - document.getElementById('header').offsetHeight - document.getElementById('footer').offsetHeight)}px`;
    } else {
      document.getElementById('webcad3dViewWrapper').style.height = `${String(height)}px`;
    }
    // 2D建具メニューのリサイズ（safari対策）

    (<HTMLElement>document.querySelector('#itemMenu_fitting .menuFrame')).style.height = `${String((<HTMLElement>document.getElementById('itemMenu_fitting')).clientHeight - (parseFloat(getComputedStyle(document.querySelector('#itemMenu_fitting .title'), null).height.replace('px', '')) + parseFloat(getComputedStyle(document.querySelector('#itemMenu_fitting .itemMenuHeader'), null).height.replace('px', ''))))}px`;
  }

  // FPS表示
  private statsInit = () => {
    const stats = new Stats();
    stats.setMode(0); // 0: fps, 1: ms, 2: mb
    stats.domElement.style.position = 'absolute';
    stats.domElement.style.right = '30px';
    stats.domElement.style.bottom = `${68}px`;
    document.body.appendChild(stats.domElement);
    const update = () => {
      stats.begin();
      stats.end();
      requestAnimationFrame(update);
    };
    requestAnimationFrame(update);
  }

  static btnHeaderSelectModeClickEventHandler(): void {
    // 表示中のダイアログを閉じる
    marietta.webcad.WebCADGlobal.removeDialog();

    // 単一選択モードへ切り替えたら、複数選択モードは解除する（選択モードのままなので明示的に）
    marietta.webcad.WebCADGlobal.webcad2Dmanager.isMultipleSelect = false;

    document.getElementById('checkSelectMode').classList.add('is-active');
    marietta.webcad.WebCADGlobal.itemMenu.hideAll();
    document.querySelectorAll('#itemMenuCategories input').forEach((element) => {
      (<HTMLInputElement>element).checked = false;
    });

    // 頂点入力モードの中断
    marietta.webcad.WebCADGlobal.itemManager.pointInputInterrupt();

    // 選択モード
    marietta.webcad.WebCADGlobal.webcad2Dmanager.updatecurrentActionModeFromItemMenu();
  }

  static btnHeaderGroupSelectModeClickEventHandler(): void {
    // 複数選択モードのON/OFFトグル（アクティブ表示は isMultipleSelect setter 側で同期）。
    // モードON中はドラッグ・タップの両方で選択でき、他モードへ切り替えると自動OFFになる。
    const nextIsMultipleSelect: boolean = !marietta.webcad.WebCADGlobal.webcad2Dmanager.isMultipleSelect;
    marietta.webcad.WebCADGlobal.webcad2Dmanager.isMultipleSelect = nextIsMultipleSelect;

    if (nextIsMultipleSelect) {
      // ONにしたときは、「選択」ボタン押下時と同様に左側の項目メニューを閉じる
      marietta.webcad.WebCADGlobal.itemMenu.hideAll();
      document.querySelectorAll('#itemMenuCategories input').forEach((element) => {
        (<HTMLInputElement>element).checked = false;
      });
    } else {
      // OFFにしたときは、選択中のアイテム（グループ含む）も解除する
      marietta.webcad.WebCADGlobal.itemManager.unselectAllCurrents();
    }
  }

  static saveBtnClickEventHandler(): void {
    // デモモードの場合は、アラートを表示する
    if (marietta.webcad.WebCADGlobal.IS_DEMO_MODE) {
      marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('DEMOMODE_ERROR_MESSAGE'), marietta.webcad.collection.WebCADMessages.getText('DEMOMODE_ERROR_TITLE'));
      return;
    }

    marietta.webcad.WebCADGlobal.webcad2Dmanager.checkLogin(marietta.webcad.WebCADGlobal.webcad2Dmanager.showSavePlanDialog, marietta.webcad.WebCADGlobal.webcad2Dmanager.showLoginDialogAndThenSaveDialog);
  }

  /**
   * モデルのリンクをコピー
   * 共有リンクを発行してクリップボードにコピーし、結果をダイアログで通知する
   */
  static copyShareLink(): void {
    const title: string = marietta.webcad.collection.WebCADMessages.getText('COPY_SHARE_LINK_TITLE');
    const errorMessage: string = marietta.webcad.collection.WebCADMessages.getText('ERROR_COPY_SHARE_LINK_FAIL');

    // 保存データがない場合はメッセージを分けるため、APIの結果を控えておく
    let isNoSavedData: boolean = false;

    const showResult = (isCopied: boolean): void => {
      if (isCopied) {
        marietta.webcad.WebCADGlobal.showAlert(marietta.webcad.collection.WebCADMessages.getText('COPY_SHARE_LINK_DONE'), title, null, true, true);
        return;
      }
      const message: string = isNoSavedData
        ? marietta.webcad.collection.WebCADMessages.getText('ERROR_COPY_SHARE_LINK_NO_SAVED_DATA')
        : errorMessage;
      marietta.webcad.WebCADGlobal.showAlert(message, title, null, true, true);
    };

    // 書き込みの結果が返らないブラウザ（フォーカスを失っている場合など）でも通知できるようにする
    const withTimeout = (writing: Promise<void>): Promise<void> => new Promise((resolve, reject) => {
      const timer = window.setTimeout(() => reject(new Error(errorMessage)), CLIPBOARD_WRITE_TIMEOUT_MS);
      writing.then(
        () => { window.clearTimeout(timer); resolve(); },
        (err) => { window.clearTimeout(timer); reject(err); },
      );
    });

    const shareUrl: Promise<string> = marietta.webcad.manager.APIManager.createShareLink()
      .then((result) => {
        isNoSavedData = result.isNoSavedData;
        if (!result.shareLink || !result.shareLink.share_url) {
          throw new Error(errorMessage);
        }
        return result.shareLink.share_url;
      });

    // 予約方式が使えない環境では、URLを取得してから書き込む
    const copyByWriteText = (): void => {
      withTimeout(shareUrl.then((url) => navigator.clipboard.writeText(url)))
        .then(() => showResult(true))
        .catch((err) => {
          console.error(err);
          showResult(false);
        });
    };

    // Safari（iPadのChromeも同じ）はタップ直後しかクリップボードへの書き込みを許可しないため、
    // 書き込みを先に予約し、URLはPromiseで後から渡す
    try {
      const item = new ClipboardItem({
        [CLIPBOARD_TEXT_MIME_TYPE]: shareUrl.then((url) => new Blob([url], { type: CLIPBOARD_TEXT_MIME_TYPE })),
      });
      withTimeout(navigator.clipboard.write([item]))
        .then(() => showResult(true))
        .catch((err) => {
          console.error(err);
          copyByWriteText();
        });
    } catch (err) {
      console.error(err);
      copyByWriteText();
    }
  }

  static webcadCloseBtnClickEventHandler = (e: Event): void => {
    e.preventDefault();
    // デモモードは何もしない
    if (marietta.webcad.WebCADGlobal.IS_DEMO_MODE) {
      return;
    }

    // 表示モードの場合は、直接 Web サイトに戻ります
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.startup_mode === 0) {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged = false;
    }
    // 参照モードの時、変更が加えられていないときはどのまま閉じる
    if (!(marietta.webcad.WebCADGlobal.webcad2Dmanager.isChanged || marietta.webcad.WebCADGlobal.webcad2Dmanager.bukenId === 0) || marietta.webcad.WebCADGlobal.webcad2Dmanager.mode === '2') {
      // ページ更新確認ダイアログを一時的に解除
      window.removeEventListener('beforeunload', marietta.webcad.WebCADGlobal.pageBeforeUnload);
      // 操作後、保存済みの場合は一覧へ戻す
      // eslint-disable-next-line no-restricted-globals
      // marietta.webcad.WebCADGlobal.showAlert('ブラウザを閉じてください。');
      // 終了時に連携しているパラメータをもとに画面遷移
      marietta.webcad.WebCADGlobal.backLiDARPage();
      // location.href = marietta.webcad.WebCADGlobal.webcad2Dmanager.saved_url;
    } else {
      // 保存確認ダイアログの表示
      marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.ConfirmSavePlan);
    }
  }

  // ヘルプメッセージを表示する
  static setHelpMsgByTimer() {
    // 表示位置調整
    document.getElementById('helpMessage').style.right = `${document.getElementById('webcad2dViewInner').offsetWidth - document.getElementById('webcad2dViewInner').clientWidth}px`;
    document.getElementById('helpMessage').style.bottom = `${document.getElementById('webcad2dViewInner').offsetHeight - document.getElementById('webcad2dViewInner').clientHeight + document.querySelector('footer').getBoundingClientRect().height}px`;

    function showHelpMsg() {
      document.getElementById('helpMessage').style.opacity = '1';
    }
    function hideHelpMsg() {
      document.getElementById('helpMessage').style.opacity = '0';
    }
    // 一定時間操作がなかったら表示
    const timeLimit: number = 1.5 * 1000;
    let timerId = setTimeout(showHelpMsg, timeLimit);
    ['keydown', 'click', 'mousemove'].forEach((e) => {
      document.addEventListener(e, () => {
        clearTimeout(timerId);
        hideHelpMsg();
        timerId = setTimeout(showHelpMsg, timeLimit);
      });
    });
    // spaceキーを使用せずに、スクロール実行したら表示する
    document.getElementById('webcad2dViewInner').addEventListener('scroll', () => {
      if (!marietta.webcad.WebCADGlobal.webcad2Dmanager._input_key_buffer[32]) showHelpMsg();
    });
  }

  // スマホタブレット
  private spOrTabletInit = (): void => {
    // 拡大縮小禁止（ブラウザ標準ピンチ・ダブルタップ拡大の抑止）。
    // 作図ビュー(#webcad2dViewInner)内の2本指ピンチズームは、Safari GestureEvent
    // (gesturestart/change/end) をScrollerManagerで受けて処理する（LayerGroupで登録）。
    document.addEventListener('touchstart', (event: any) => {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    }, { passive: false });

    // ダブルタップ拡大禁止
    let t = 0;
    document.documentElement.addEventListener('touchend', (e) => {
      const now = new Date().getTime();
      if ((now - t) < 350) {
        e.preventDefault();
      }
      t = now;
    }, { passive: false });
  }

  // デバッグモードに設定
  private setToDebugMode = (): void => {

    // デバッグモードの表記追加
    const element: Element = document.createElement('span');
    element.textContent = 'DEBUG MODE';
    element.setAttribute('style', 'top:60px; left:80px; color:red; font-size:30px; position:absolute');
    document.getElementsByTagName('body')[0].appendChild(element);

    // インポート、エクスポート機能
    if (document.getElementById('btnImport') == null) {
      const link = document.getElementById('headerMenuSelect');
      const menu = document.createElement('li');
      menu.setAttribute('id', 'headerMenuFile');
      menu.setAttribute('class', 'headerDropdownTrigger');
      const insertButton = '<button class=""><span class="icon icon-file"></span><span class="iconName"><span class="jp">ファイル</span><span class="en">File</span></span></button><div class="headerDropdownList"><ul><li class="js-notForMobile"><button id="btnImport"><span class="jp">インポート</span><span class="en">Import</span></button><input type="file" id="filePicker" accept=".xml"></li><li class="js-notForMobile"><button id="btnExport"><span class="jp">エクスポート</span><span class="en">Export</span></button></li></ul></div>';
      menu.innerHTML = insertButton;
      link.parentNode.insertBefore(menu, link.nextSibling);
      document.getElementById('btnImport').addEventListener('click', () => {
        // 連続して同じファイルを選択できるように初期化
        (<HTMLInputElement>document.getElementById('filePicker')).value = null;
        document.getElementById('filePicker').click();
      });
      document.getElementById('btnExport').addEventListener('click', () => {
        const jsonData: String = marietta.webcad.util.WebcadJSONExporter.createWebCADData();
        marietta.webcad.WebCADGlobal.webcad2Dmanager.exportPlan(jsonData);
      });

      // k.kubonaka FireFoxでインポート時にエラー。function()内にeventを追加
      document.getElementById('filePicker').addEventListener('change', (event) => {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.readPlan(event);
      });
    }

    // デバッグメニュー（「ファイル」メニューの隣に置くため、その生成後に呼ぶ）
    new BuildDebugMenu().setTools();
  }

  /**
   * 角度を指定...が選択された
   */
  private onClickInputCompassDegrees = (): void => {
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.CompassInputDegrees);
  }

  /**
   * 2点を指定...が選択された
   */
  private onClickInputCompass2Points = (): void => {
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.CompassPointInputDialog);
  }

  /**
   * 表示設定のカスタマイズに使用する機能.
   * CustomizeDisplayDialogダイアログボックスのトリガー
   * グリッドカラー、背景色、squareUnitマージグリッド機能を扱う
   * @return void
   */
  private btnCustomizeDisplay = (): void => {
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.CustomizeDisplayDialog);
  }

  /**
   * 巾木設定
   */
  private btnCustomizeHabaki = (): void => {
    marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.CustomizeHabakiDialog);
  }

}

// アプリケーション開始
// noinspection JSUnusedLocalSymbols
const _main: Main = new Main();
